/*
 * Copyright (c) 2013 SGS Europe. All rights reserved.
 *
 * This program is the CONFIDENTIAL and PROPRIETARY property of 2013 SGS Europe.
 * Any unauthorised use, reproduction, or transfer of this program is strictly
 * prohibited.
 *
 * File Name:	InsightControlValidation.js
 *
 * Description:	functions required for the performing of validation for Insight specific server controls.
 *
 */

/*
 *	- - - A S S I G N M E N T  - - -
 */

var c_regExAlphaNumeric = /^[a-zA-Z0-9]*$/;
var c_regExDecimal = /^-?([0-9]+)+\.?[0-9]*$/;
var c_regExEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z0-9]{2,}))$/;
var c_regExIntOnly = /^-?[0-9]+$/;
var c_regExPassword = null;
var c_regExTextOnly = /^[a-zA-Z]*$/;
var c_regExHexadecimal = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
var c_regExNoneNumerical = /^[^0-9]+$/;

// Set up these values (used only when required) to avoid errors
var c_szNone = "";
var c_szAlphaNumeric = "";
var c_szInteger = "";
var c_szDecimal = "";
var c_szCost = "";
var c_szDate = "";
var c_szHexadecimal = "";
var c_szNoneNumerical = "";
var c_szBarcode = "";
var c_szEmail = "";

var c_szTextBox = "";
var c_szMultilineTextBox = "";
var c_szSelectList = "";
var c_szCheckBox = "";
var c_szDateControl = "";
var c_szBarcode = "";
var c_szMultiSelectList = "";
var c_szCalculation = "";
var c_szRichText = "";

// Enum of the types of Metadata values that the Search Criteria can use.
var eMetadataValueTypes = {
	None: 0,
	Value: 1,
	BarcodeNumber: 2,
	BarcodeType: 3,
	MultiSelectList: 4
}

function getFieldTypeName(typeId) {
	var szFieldTypeName = "";

	switch (typeId) {
		case g_eMetadataFieldType.Text:
			szFieldTypeName = c_szTextBox;
			break;
		case g_eMetadataFieldType.MultiText:
			szFieldTypeName = c_szMultilineTextBox;
			break;
		case g_eMetadataFieldType.Select:
			szFieldTypeName = c_szSelectList;
			break;
		case g_eMetadataFieldType.Check:
			szFieldTypeName = c_szCheckBox;
			break;
		case g_eMetadataFieldType.Date:
			szFieldTypeName = c_szDateControl;
			break;
		case g_eMetadataFieldType.SectionHeader:
			szFieldTypeName = "";
			break; // Don't need to display field type text for section header.
		case g_eMetadataFieldType.Barcode:
			szFieldTypeName = c_szBarcode;
			break;
		case g_eMetadataFieldType.MultiSelectList:
			szFieldTypeName = c_szMultiSelectList;
			break;
		case g_eMetadataFieldType.Calculation:
			szFieldTypeName = c_szCalculation;
			break;
		case g_eMetadataFieldType.RichText:
			szFieldTypeName = c_szRichText;
			break;
	}

	return szFieldTypeName;
}

/**
 * Gets the Validation Type Prompt
 * @param {int} typeId - The validation type selected.
 * @returns {string} - The validation string.
 */
function getValidationTypeName(typeId) {
	var szValidationTypeName = "";
	switch (typeId) {
		case g_eValidationType.None:
			szValidationTypeName = c_szNone;
			break;
		case g_eValidationType.AlphaNumberic:
			szValidationTypeName = c_szAlphaNumeric;
			break;
		case g_eValidationType.Integer:
			szValidationTypeName = c_szInteger;
			break;
		case g_eValidationType.Decimal:
			szValidationTypeName = c_szDecimal;
			break;
		case g_eValidationType.Cost:
			szValidationTypeName = c_szCost;
			break;
		case g_eValidationType.Date:
			szValidationTypeName = c_szDateControl;
			break;
		case g_eValidationType.Hexadecimal:
			szValidationTypeName = c_szHexadecimal;
			break;
		case g_eValidationType.NonNumeric:
			szValidationTypeName = c_szMultiSelectList;
			break;
		case g_eValidationType.Barcode:
			szValidationTypeName = c_szBarcode;
			break;
		case g_eValidationType.Email:
			szValidationTypeName = c_szEmail;
			break;
		case g_eValidationType.RichText:
			szValidationTypeName = c_szRichText;
			break;
	}

	return szValidationTypeName;
}

// Sets the Regex
function setPasswordRegex(regex) {
	// If the value is a Regular Expression,
	// update the password Reg Ex.
	if (regex instanceof RegExp)
		c_regExPassword = new RegExp(regex);
}

/*
*	- - - U I / H I G H L I G H T   M E T H O D S - - -
*/

// Highlights an element with its Error Style.
function highlightElement(elementId, parentDiv) {
	var szCSS = "";
	var szCSSErr = "";

	var oElement = $((!isNothing(parentDiv) ? "#" + parentDiv + " " : "") + "#" + elementId);
	if (!oElement.exists()) {
		return;
	}

	if (oElement.hasClass('controlInputBox')) {
		szCSS = "controlInputBox";
		szCSSErr = "controlInputBox_Err";
	}
	else {
		switch (oElement.prop('tagName').toLowerCase()) {
			case "input":
			case "textarea":
				if (oElement.prop('type').toLowerCase() == "checkbox") {
					szCSS = "insightCheckbox";
					szCSSErr = "insightCheckboxError";
				} else if (oElement.hasClass("insightTextBoxLrg")) {
					szCSS = "insightTextBoxLrg";
					szCSSErr = "insightTextBoxLrgError";
				}
				else {
					szCSS = "insightTextBox";
					szCSSErr = "insightTextBoxError";
				}
				break;

			case "select":
				szCSS = "insightSelectList";
				szCSSErr = "insightSelectListError";
				break;

			case "ul":
				szCSSErr = "insightMultiSelectListError";
				break;

			case "span":
			case "td":
			case "a":
				szCSSErr = "insightTextBoxError";
				break;

			case "img":
				szCSSErr = "insightImageError";
				break;
		}
	}

	oElement.removeClass(szCSS);
	oElement.addClass(szCSSErr);
}

// UnHighlights an element by removing its Error Style.
function unHighlightElement(elementId, parentDiv) {
	var szCSS = "";
	var szCSSErr = "";

	var oElement = $((!isNothing(parentDiv) ? "#" + parentDiv + " " : "") + "#" + elementId);
	if (!oElement.exists()) {
		return;
	}

	if (oElement.hasClass('controlInputBox')) {
		szCSS = "controlInputBox";
		szCSSErr = "controlInputBox_Err";
	}
	else {
		switch (oElement.prop('tagName').toLowerCase()) {
			case "input":
			case "textarea":
				if (oElement.prop('type').toLowerCase() == "checkbox") {
					szCSS = "insightCheckbox";
					szCSSErr = "insightCheckboxError";
				}
				else if (oElement.prop('type').toLowerCase() == "file") {
					szCSSErr = "insightTextBoxError";
				}
				else if (oElement.hasClass("insightTextBoxLrgError")) {
					szCSS = "insightTextBoxLrg";
					szCSSErr = "insightTextBoxLrgError";
				}
				else {
					szCSS = "insightTextBox";
					szCSSErr = "insightTextBoxError";
				}
				break;

			case "select":
				szCSS = "insightSelectList";
				szCSSErr = "insightSelectListError";
				break;

			case "ul":
				szCSSErr = "insightMultiSelectListError";
				break;

			case "span":
			case "td":
				szCSSErr = "insightTextBoxError";
				break;

			case "img":
				szCSSErr = "insightImageError";
				break;
		}

		oElement.removeClass(szCSSErr);
		oElement.addClass(szCSS);
	}
}

/*
 *	- - - V A L I D A T I O N   M E T H O D S - - -
 */

// Checks to see if a select list has a selected item and highlights if not.
function checkHasSelection(ctrl) {
	var szValue = getSelectedListItemValue(ctrl.id);
	var bReturn = false;

	if (szValue == "" || szValue == "0") {
		highlightElement(ctrl.id);
		bReturn = false;
	} else {
		unHighlightElement(ctrl.id);
		bReturn = true;
	}

	return bReturn;
}

function validateInsightControl(ctrl) {
	var bReturn = true;

	// Get the controls attributes.
	var szElementId = $(ctrl).attr("id");
	var szElementType = $(ctrl).prop('tagName');
	var szElementValue = "";
	var bRequired = ($(ctrl).attr("IsRequired") == "true" ? true : false);
	var szValidationType = $(ctrl).attr("validationType");
	if (szValidationType == undefined || szValidationType.toLowerCase() == "none")
		szValidationType = "";

	// Unhighlight the control first.
	unHighlightElement(szElementId);
	if ($("#" + szElementId + "_ValErr").exists()) {
		$("#" + szElementId + "_ValErr").toggle(false);
	}
	if ($("#" + szElementId + "_UniqueErr").exists()) {
		$("#" + szElementId + "_UniqueErr").toggle(false);
	}

	if (!isNothing(szElementType)) {
		switch (szElementType.toLowerCase()) {
			case "input":
			case "textarea":
				szElementValue = trim($("#" + szElementId).val());
				break;
			case "select":
				szElementValue = getSelectedListItemValue(szElementId);
				break;
		}
	}

	// Validate if needed and we have a value.
	if (szValidationType.length > 0 && (typeof szElementValue === 'undefined' || szElementValue.length > 0)) {
		switch (szValidationType.toLowerCase()) {
			case "text":
				bReturn = validateText(szElementId, szElementValue);
				break;
			case "password":
				bReturn = validatePassword(szElementId, szElementValue);
				break;
			case "email":
				bReturn = validateEmail(szElementId, szElementValue);
				break;
			case "integer":
				bReturn = validateInteger(szElementId, szElementValue);
				break;
			case "decimal":
				bReturn = validateDecimal(szElementId, szElementValue);
				break;
			case "hexadecimal":
				bReturn = validateHexadecimal(szElementId, szElementValue);
				break;
			case "nonenumerical":
				bReturn = validateNoneNumerical(szElementId, szElementValue);
				break;
			default:
				bReturn = true;
				break;
		}
	} // Otherwise make sure we have a value if the field is required.
	else if (bRequired && (typeof szElementValue === 'undefined' || szElementValue.length === 0)) {
		highlightElement(szElementId);
		bReturn = false;
	}

	return bReturn;
}

// Ensures the value contains only Alpha numeric characters.
function validateAlphaNumeric(elementId, value) {
	var bReturn = true
	if (!c_regExAlphaNumeric.test(value)) {
		highlightElement(elementId);
		if ($("#" + elementId + "_ValErr").exists()) {
			$("#" + elementId + "_ValErr").css("display", "inline");
		}
		bReturn = false;
	}
	return bReturn
}

// Ensures the value is a decimal.
function validateDecimal(elementId, value) {
	var bReturn = true
	if (!c_regExDecimal.test(value)) {
		highlightElement(elementId);
		if ($("#" + elementId + "_ValErr").exists()) {
			$("#" + elementId + "_ValErr").css("display", "inline");
		}
		bReturn = false;
	}
	else if (c_regExIntOnly.test(value)) {
		$("#" + elementId).val(value + ".0");	// If the value contains just numbers, append ".0"
	}
	else if (value == ".") {
		$("#" + elementId).val("0" + value + "0");	// If the value is just a decimal point, prepend and append "0"
	}
	else if (value.substring(value.length - 1) == ".") {
		$("#" + elementId).val(value + "0");	// If the value ends with a decimal point, append "0"
	}
	else if (value.substring(0, 1) == ".") {
		$("#" + elementId).val("0" + value);	// If the value starts with a decimal point, prepend "0"
	}
	return bReturn
}

// Ensures the value matches that of a standard email address.
function validateEmail(elementId, value) {
	var bReturn = true;
	if (!c_regExEmail.test(value)) {
		highlightElement(elementId);
		if ($("#" + elementId + "_ValErr").exists()) {
			$("#" + elementId + "_ValErr").css("display", "inline");
		}
		bReturn = false;
	}

	return bReturn;
}

// Ensures the value consists of hex code - # followed by 3 / 6  valid chars.
function validateHexadecimal(elementId, value) {
	var bReturn = true
	if (!c_regExHexadecimal.test(value)) {
		highlightElement(elementId);
		if ($("#" + elementId + "_ValErr").exists()) {
			$("#" + elementId + "_ValErr").css("display", "inline");
		}
		bReturn = false;
	}
	return bReturn;
}

// Ensures the value consists of integer characters (0-9) only.
function validateInteger(elementId, value) {
	var bReturn = true
	if (!c_regExIntOnly.test(value)) {
		highlightElement(elementId);
		if ($("#" + elementId + "_ValErr").exists()) {
			$("#" + elementId + "_ValErr").css("display", "inline");
		}
		bReturn = false;
	}
	return bReturn;
}

// Ensures the value consists of none integer characters (0-9).
function validateNoneNumerical(elementId, value) {
	var bReturn = true
	if (!c_regExNoneNumerical.test(value)) {
		highlightElement(elementId);
		if ($("#" + elementId + "_ValErr").exists()) {
			$("#" + elementId + "_ValErr").css("display", "inline");
		}
		bReturn = false;
	}
	return bReturn;
}

// Ensures the value meets the password policy.
function validatePassword(elementId, value) {
	var bReturn = true;
	var szPasswordRegEx = /(?=^.{6,}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*$/;

	if (!isNothing(c_regExPassword)) {
		// Make sure the password meets the policy (Set by the customer).
		if (!c_regExPassword.test(value)) {
			highlightElement(elementId);
			if ($("#" + elementId + "_ValErr").exists()) {
				$("#" + elementId + "_ValErr").css("display", "inline");
			}
			bReturn = false;
		}
	}
	return bReturn;
}

// Ensures the value consists of text characters (A-Z) only.
function validateText(elementId, value) {
	var bReturn = true
	var szTextOnlyRegEx = /^[a-zA-Z]*$/;
	if (!c_regExTextOnly.test(value)) {
		highlightElement(elementId);
		if ($("#" + elementId + "_ValErr").exists()) {
			$("#" + elementId + "_ValErr").css("display", "inline");
		}
		bReturn = false;
	}
	return bReturn;
}

/*
 *	- - - C H E C K   D I G I T   V A L I D A T I O N   M E T H O D S - - -
 */

//Returns the check digit number
function barcodeCheckDigit(BarcodeNumber, BarcodeType) {
	var iCheckDigitNumber = 0;

	switch (BarcodeType) {
		case "1":	//Code 25
			// 1. Weight each digit with either a 3 or a 1, starting from the left and alternating.
			for (var i = 0; i < BarcodeNumber.length - 1; i++) {
				// 2. Sum the value of each weighting.
				if (isOdd(i + 1)) {
					iCheckDigitNumber += (BarcodeNumber[i] * 3);
				}
				else {
					iCheckDigitNumber += (BarcodeNumber[i] * 1);
				}
			}

			// 3. MOD 10 the result.
			iCheckDigitNumber = mod(iCheckDigitNumber, 10);

			// 4. Subtract the result from 10 to get the check digit.
			iCheckDigitNumber = (10 - iCheckDigitNumber);
			break;

		case "2":	//Code 39
			// 1. Sum together the Code39 (not ASCII) values of each character in the barcode.
			for (var i = 0; i < BarcodeNumber.length - 1; i++) {
				var asciiValue = BarcodeNumber.toUpperCase().charCodeAt(i);
				iCheckDigitNumber += ConvertCharToCode39(asciiValue);
			}

			// 2. MOD 43 the result.
			iCheckDigitNumber = mod(iCheckDigitNumber, 43);

			// 3. Convert this Code39 value into a character to get the checksum character.
			iCheckDigitNumber = ConvertCode39ToChar(iCheckDigitNumber);
			break;

		case "3":	//Code 128
			var szCode128Regex_TypeC = new RegExp("^[0-9]+$");
			var szCode128Regex_TypeB = new RegExp("[a-z]");
			var iStartCode;
			if (BarcodeNumber.match(szCode128Regex_TypeC)) {
				iStartCode = 105; 	// C	(If the full string consists of numeric values, code type is 'C')
				if (BarcodeNumber.length % 2 == 1) {
					BarcodeNumber = "0" + BarcodeNumber;	// If the length of type C barcode is not even, pad the front with a 0.
				}
			}
			else if (BarcodeNumber.match(szCode128Regex_TypeB)) {
				iStartCode = 104; 	// B	(If we have lower case letters we know this cant be type A so must be 'B')
			}
			else {
				iStartCode = 103; 	// A	(Doesn't consist of numbers and doesn't have lowercase chars so must be 'A')
			}

			// Perform the Check digit calculation with the correct Start Code.
			iCheckDigitNumber = CalcCheckDigit128(BarcodeNumber, iStartCode);
			break;

		case "5":	//EAN-8
		case "6":	//EAN-13
			// If the source message string is greater than 12 characters long, we make it 12 characters
			if (BarcodeNumber.length > 12) {
				BarcodeNumber = BarcodeNumber.substring(0, 12);
			}

			// If the source message string is less than 12 characters long, we make it 12 characters
			if (BarcodeNumber.length < 12) {
				var strHold = '000000000000' + BarcodeNumber.substring(0, BarcodeNumber.length - 1);
				BarcodeNumber = strHold.substring(strHold.length - 12, strHold.length);
			}

			// Calculate the checksum value for the message
			for (charPos = BarcodeNumber.length - 1; charPos >= 0; charPos--) {
				if (charPos / 2 == parseInt(charPos / 2)) {
					iCheckDigitNumber = iCheckDigitNumber + (parseInt(BarcodeNumber.substring(charPos, charPos + 1)));
				}
				else {
					iCheckDigitNumber = iCheckDigitNumber + (3 * parseInt(BarcodeNumber.substring(charPos, charPos + 1)));
				}
			}

			// Calculate the checksum digit
			var remainder = iCheckDigitNumber - parseInt(iCheckDigitNumber / 10) * 10;

			if (remainder == 0) {
				iCheckDigitNumber = '0';
			}
			else {
				iCheckDigitNumber = 10 - remainder;
			}
			break;

		case "8":	//ITF-14
			var csumTotal = 0; // The checksum working variable starts at zero

			/// remove the checksum from the passed barcode.
			BarcodeNumber = BarcodeNumber.substring(0, 13);

			// Calculate the checksum value for the message
			for (charPos = BarcodeNumber.length - 1; charPos >= 0; charPos--) {
				if (charPos / 2 == parseInt(charPos / 2)) {
					csumTotal = csumTotal + (3 * parseInt(BarcodeNumber.substring(charPos, charPos + 1)));
				}
				else {
					csumTotal = csumTotal + (parseInt(BarcodeNumber.substring(charPos, charPos + 1)));
				}
			}

			// Calculate the checksum digit
			var remainder = csumTotal - parseInt(csumTotal / 10) * 10;

			if (remainder == 0) {
				iCheckDigitNumber = '0';
			}
			else {
				iCheckDigitNumber = 10 - remainder;
			}

			return iCheckDigitNumber;
			break;

		case "10":	//MSI
			// 1. Create a new number using every other digit from the original code such that the right-most digit of the new number is the right-most digit of the old number.
			var szNewNumber = "";
			var iSum = 0;
			var bFlag = true;

			for (var i = BarcodeNumber.length - 2; i >= 0; i--) {
				if (bFlag) {
					szNewNumber = BarcodeNumber[i] + szNewNumber;
				}
				else {
					iSum += parseInt(BarcodeNumber[i]);
				}
				bFlag = !bFlag;
			}

			// 2. Take the new number calculated in step 1 and multiply it by 2.
			szNewNumber = (parseInt(szNewNumber, 10) * 2).toString();

			// 3. Add the digits of the value calculated in the previous step (4), and add it to the digits that were not used in step 1 to form the new number.
			for (var i = 0; i < szNewNumber.length; i++) {
				iSum += parseInt(szNewNumber[i], 10);
			}

			//4. Do a modulo 10 calculation on the result of step 3.
			var iCheckDigitNumber = mod(iSum, 10);

			//5. The check digit is the value which, added to the result in step 4, equals 10.
			iCheckDigitNumber = 10 - iCheckDigitNumber;
			break;

		case "11":	//PZN
			// For 8 digit PZN barcodes, if the barcode begins with a 0 we ignore it.
			if (BarcodeNumber.length == 8 && BarcodeNumber.substr(0, 1) == 0) {
				BarcodeNumber = BarcodeNumber.substr(1, BarcodeNumber.length - 1);
			}

			for (var i = 0; i < (BarcodeNumber.length - 1); i++) {
				var digit = BarcodeNumber.substr(i, 1);
				// Multiply the first digit by 2, the second digit by 3, ... the sixth digit by 7
				iCheckDigitNumber += digit * (i + 2);
			}

			// Add the results and divide it by 11 and the remainder is the check digit.
			iCheckDigitNumber = iCheckDigitNumber % 11;
			break;

		case "13":	//UPC-A
		case "14":	//UPC-E
			if (BarcodeType == 14) {
				BarcodeNumber = ConvertUPCE2A(BarcodeNumber);
			}

			// calculate the check digit - note UPCE and UPCA check digits are the same
			for (var X = 1; X <= 11; X++) {
				var Test = BarcodeNumber.substr(X - 1, 1);
				if (isOdd(X)) {
					iCheckDigitNumber = iCheckDigitNumber + parseInt(Test) * 7; // odd position digits multiplied by 7
				}
				else {
					iCheckDigitNumber = iCheckDigitNumber + parseInt(Test) * 9; // even position digits multiplied by 9
				}
			}

			iCheckDigitNumber = (iCheckDigitNumber % 10) + 48;					// convert value to ASCII character value;
			iCheckDigitNumber = charFromCharCode(iCheckDigitNumber);			// check character
			break;

		case "16":	//Interleave 2 of 5

		default:	//Data matrix, EAN-128, Laetus, QR
			iCheckDigitNumber = -4;
			break;
	}

	return iCheckDigitNumber;
}

// Function to calculate the check digit of a Code128 barcode.
function CalcCheckDigit128(barcode, startCode) {
	var szCheckDigit = 0;
	var iTotal = startCode;

	var eCode128Type = {
		A: 10,
		B: 20,
		C: 30
	};

	var eBarcodeSubset;
	switch (startCode) {
		case 103:      // A
			eBarcodeSubset = eCode128Type.A;
			break;
		case 104:      // B
			eBarcodeSubset = eCode128Type.B;
			break;
		case 105:		// C
			eBarcodeSubset = eCode128Type.C
			break;
	}

	// Calculate for SubSets A & B.
	if (eBarcodeSubset == eCode128Type.A || eBarcodeSubset == eCode128Type.B) {
		for (var i = 0; i < barcode.length; i++) {
			// Determine the ASCII value of the character at position i.
			var iAsciiValue = barcode.charCodeAt(i) - 32;

			// Calculate the running total.
			iTotal += (iAsciiValue * (i + 1));
		}
	}
	else {
		// Calculate for SubSet C.
		var iIndex = 1;
		for (var i = 0; i < barcode.length; i += 2) {
			// Determine the ASCII value of the character at position i.
			var iPairedValue = parseInt(barcode.substr(i, 2));

			// Calculate the running total.
			iTotal += (iPairedValue * iIndex);
			iIndex++;
		}
	}

	// Mod the result by 103, the output represent an ASCII char.
	var iResult = iTotal % 103;

	/*
	Subset A
		if (the checksum is between 0 and 63)
			add the checksum and the ASCII code for a space (32) to obtain the character code.
		If (the checksum is 64 or higher)
			subtract 64 to obtain the character code.
	Subset B + C
		If (the checksum is 94 or lower)
			add the checksum and the ASCII code for a space (32).
		Otherwise
			Add 100
	*/

	var iCheckChar;

	if (eBarcodeSubset == eCode128Type.A) {					// A
		if (iResult < 64)
			iCheckChar = iResult + 32;
		else
			iCheckChar = iResult - 64;
	}
	else {			// B + C
		iCheckChar = (iResult < 95 ? iResult + 32 : iResult + 100);
	}

	szCheckDigit = charFromCharCode(iCheckChar);

	return szCheckDigit;
}

function charFromCharCode(charCode) {
	if (isNaN(charCode)) {
		throw "charFromCharCode: wrong char code [" + charCode + "]";
	}
	var res = String.fromCharCode(charCode);
	return res;
}

function ConvertCharToCode39(value) {
	var result;
	switch (true) {
		case (value > 47 && value < 58): // 0-9
			result = value - 48;
			break;
		case (value > 64 && value < 91): // A-Z
			result = value - 55;
			break;
		case (value == 32): // space
			result = 38;
			break;
		case (value == 36): // $
			result = 39;
			break;
		case (value == 37): // %
			result = 42;
			break;
		case (value == 42): // *
			result = 0;
			break;
		case (value == 43): // +
			result = 41;
			break;
		case (value == 45): // -
			result = 36;
			break;
		case (value == 46): // .
			result = 37;
			break;
		case (value == 47): // /
			result = 40;
			break;
	}
	return result;
}

function ConvertCode39ToChar(value) {
	var result;

	switch (true) {
		case (value < 10): // 0-9
			result = charFromCharCode(value + 48);
			break;
		case (value > 9 && value < 36): // A-Z
			result = charFromCharCode(value + 55);
			break;
		case (value == 36): // -
			result = charFromCharCode(45);
			break;
		case (value == 37): // .
			result = charFromCharCode(46);
			break;
		case (value == 38): // space
			result = charFromCharCode(32);
			break;
		case (value == 39): // $
			result = charFromCharCode(36);
			break;
		case (value == 40): // /
			result = charFromCharCode(47);
			break;
		case (value == 41): // +
			result = charFromCharCode(43);
			break;
		case (value == 42): // %
			result = charFromCharCode(37);
			break;
		case (value == 0): // *
			result = charFromCharCode(42);
			break;
	}

	return result;
}

function ConvertUPCE2A(UPCE) {
	var UPCEString = new String();
	var ManufacturerNumber = new String();
	var ItemNumber = new String();
	var Msg = new String();

	if (!isANumber(UPCE)) {
		throw "UPCs must contain numeric data only!";
	}

	switch (UPCE.length) {
		case 6:
			UPCEString = UPCE;
			break;
		case 7:
			UPCEString = UPCE.substring(1, 7);
			break;
		case 8:
			if (UPCE.substring(1, 1) == 0)
				UPCEString = UPCE.substring(1, 7);
			else
				UPCEString = UPCE.substring(2, 8);
			break;
		default:
			throw "Wrong size UPCE message!";
	}

	// break up the string into its 6 individual digits
	var digits = UPCEString.split('');
	switch (digits[5]) {
		case "0":
			ManufacturerNumber = ManufacturerNumber.concat(digits[0], digits[1], digits[5], "00");
			ItemNumber = ItemNumber.concat("00", digits[2], digits[3], digits[4]);
			break;
		case "1":
			ManufacturerNumber = ManufacturerNumber.concat(digits[0], digits[1], digits[5], "00");
			ItemNumber = "00" + digits[2] + digits[3] + digits[4];
			break;
		case "2":
			ManufacturerNumber = digits[0] + digits[1] + digits[5] + "00";
			ItemNumber = "00" + digits[2] + digits[3] + digits[4];
			break;
		case "3":
			ManufacturerNumber = digits[0] + digits[1] + digits[2] + "00";
			ItemNumber = "000" + digits[3] + digits[4];
			break;
		case "4":
			ManufacturerNumber = digits[0] + digits[1] + digits[2] + digits[3] + "0";
			ItemNumber = "0000" + digits[4];
			break;
		default:
			ManufacturerNumber = ManufacturerNumber.concat(digits[0], digits[1], digits[2], digits[3], digits[4]);
			ItemNumber = ItemNumber.concat("0000", digits[5]);
			break;
	}

	// put the number system digit "0" together with the manufacturer code and Item number
	Msg = Msg.concat("0", ManufacturerNumber, ItemNumber);
	return Msg;
}

function isANumber(x) {
	var i = parseInt(x);
	return typeof i === "number" && !isNaN(i);
}

function isEmptyOrSpaces(str) {
	return str === null || str.match(/^ *$/) !== null;
}

function isEven(y) {
	return (y % 2) ? false : true;
}

function isOdd(y) {
	return !isEven(y);
}

function mod(divisee, base) {
	return divisee % base;
}


//// Checks the format and check digit of the barcode number and type provided.
/// iReturn Returned:
// -4: Not Supported
// -3: Invalid Format
// -2: Both Number and Type Missing
// -1: Either Number or Type Missing
// 0+: Check Digit
// AZ: Check Digit
function validateBarcodeCheckDigit(BarcodeNumber, BarcodeType) {
	var iReturn = 0;
	var bBarcodeFormat = true;
	var szBarcode_Regex = "";

	//Neither Number or Type entered
	if (isEmptyOrSpaces(BarcodeNumber) && isEmptyOrSpaces(BarcodeType)) {
		iReturn = -2;
		return iReturn;
	}

	//One of Number and Type entered
	if (isEmptyOrSpaces(BarcodeNumber) || isEmptyOrSpaces(BarcodeType)) {
		iReturn = -1;
		return iReturn;
	}
	//Set the Regex for each barcode type
	 switch (BarcodeType) {
		case "1":	//Code 25
			szBarcode_Regex = "^[0-9]*$"; // Any length of characters matching the following: 0-9
			break;

		case "2":	//Code 39
			szBarcode_Regex = "^[0-9A-Z\-.$/\+%\*\s]*$"; // Any length of characters matching the following: 0-9 A-Z - . {space}	$	/	+	%	*
			break;

		case "4":	//Data matrix
			szBarcode_Regex = /^[a-zA-Z0-9,\-\/\(\)]*$/; // Any length of characters matching the following: 0-9 a-z A-Z , - /, ()
			break;

		case "5":	//EAN-8
			szBarcode_Regex = "^[0-9]*$"; // Any length of characters matching the following: 0-9
			if (BarcodeNumber.length != 8) {
				bBarcodeFormat = false;
			}
			break;

		case "6":	// EAN-13
			szBarcode_Regex = "^[0-9]*$"; // Any length of characters matching the following: 0-9
			if (BarcodeNumber.length != 13) {
				bBarcodeFormat = false;
			}
			break;

		case "7":	//EAN-128
			szBarcode_Regex = "^[0-9A-Z\(\)]*$"; // Any length of characters matching the following: 0-9	A-Z	(	)
			break;

		case "8":	//ITF-14
			if (BarcodeNumber.length != 14) {
				bBarcodeFormat = false;
			}
			szBarcode_Regex = ".*"; // Any length of any characters
			break;

		case "9":	//Laetus
			szBarcode_Regex = "^[0-9]{1,6}$"; // Up to six characters of the following: 0-9
			break;

		case "10":	//MSI
			szBarcode_Regex = "^[0-9]*$"; // Any length of characters matching the following: 0-9
			break;

		case "11":	//PZN
			if (BarcodeNumber.length != 7 && BarcodeNumber.length != 8) {
				bBarcodeFormat = false;
			}
			szBarcode_Regex = "^[0-9]*$"; // Any length of characters matching the following: 0-9
			break;

		case "13":	//UPC-A
			szBarcode_Regex = "^[0-9]*$"; // Any length of characters matching the following: 0-9
			if (BarcodeNumber.length != 12) {
				bBarcodeFormat = false;
			}
			break;

		case "14":	//UPC-E
			szBarcode_Regex = "^[0-9]*$"; // Any length of characters matching the following: 0-9
			if (BarcodeNumber.length < 6 || BarcodeNumber.length > 8) {
				bBarcodeFormat = false;
			}
			break;
		case "15":	//NONE
			szBarcode_Regex = "^$"; // Empty string.
			break;
		case "16":	//Interleave 2 of 5
			szBarcode_Regex = "^[0-9]*$"; // Digits only (0-9); empty string allowed
			// Check that the barcode contains an even number of digits.
			// If the barcode length is odd, the barcode format is invalid.
			if (BarcodeNumber.length % 2 !== 0) {
				bBarcodeFormat = false;
			}
			break;
		default:	//Code 128, QR
			szBarcode_Regex = ".*"; // Any length of any characters
			break;
	}

	//Check if the barcode number does not match the Regex
	if (!BarcodeNumber.match(szBarcode_Regex) || BarcodeNumber.toUpperCase() == "TBC" || BarcodeNumber.toUpperCase() == "NONE") {
		bBarcodeFormat = false;
	}

	//If the Regex did not match, return -3. Otherwise run the CheckDigit.
	if (bBarcodeFormat == false) {
		iReturn = -3;
		return iReturn;
	}

	iReturn = barcodeCheckDigit(BarcodeNumber, BarcodeType);
	return iReturn;
}